import { Box, Typography } from "@mui/material";

const SectionHeader = ({
  section, // Propriedade usada para formulários dinâmicos (objeto de seção)
  title, // Propriedade usada para cabeçalhos estáticos (string)
  icon: IconComponent, // Propriedade usada para cabeçalhos estáticos (componente de ícone)
}) => {
  // Determina qual título exibir: prioriza 'section.section', depois 'title', e por último um fallback.
  const displayTitle =
    typeof section === "string"
      ? section
      : section?.section || title || "Seção";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 1,
        mb: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
        {/* Renderiza o ícone se ele for fornecido */}
        {IconComponent && <IconComponent className="me-2" size={20} />}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            mb: 0.5,
            textTransform: "uppercase",
            fontSize: 18,
          }}
          className="section-border"
        >
          {displayTitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default SectionHeader;
